<template>
  <div class="vue-flash-messages">
    <flash-messages />
  </div>
</template>

<script>
  import { each, includes } from 'lodash'
  import FlashMessages from 'Components/flash_messages/FlashMessages.vue'
  import FlashMessageService from 'Services/FlashMessages'

  function readFlashMessagesInitializer (root = document) {
    const element = root.querySelector('#flash-messages-initializer')

    if (!element) {
      return []
    }

    const match = element.textContent.match(/window\.dkFlashMessages\s*=\s*([\s\S]+)/)

    if (!match) {
      return []
    }

    const flashMessages = JSON.parse(match[1].trim())

    element.remove()

    return flashMessages
  }

  function displayFlashMessages (flashMessages = []) {
    if (!flashMessages || flashMessages.length === 0) {
      return
    }

    each(flashMessages, msg => {
      // split on ':' to allow for more sophisticated options to be passed through
      let opts = msg[0].split(':')
      let method = opts[0]
      opts.splice(0, 1)
      let optsDict = {}

      if (opts.length > 0) {
        if (includes(opts, 'indefinite')) {
          optsDict.timeout = 0
          optsDict.clickClose = false
        }

        // put any more options you want to pass through here
      }

      FlashMessageService[method](msg[1], null, optsDict)
    })
  }

  function consumeWindowFlashMessages () {
    const flashMessages = window.dkFlashMessages || []

    window.dkFlashMessages = []

    return flashMessages
  }

  export default {
    name: 'flash-alert-app',
    components: {
      FlashMessages,
    },
    mounted () {
      this.beforeRenderHandler = event => {
        displayFlashMessages(readFlashMessagesInitializer(event.detail.newBody))
      }

      document.addEventListener('turbo:before-render', this.beforeRenderHandler)
      displayFlashMessages(consumeWindowFlashMessages())
    },
    beforeDestroy () {
      document.removeEventListener('turbo:before-render', this.beforeRenderHandler)
    },
  }
</script>
